module.exports = __webpack_public_path__ + "media/categories/1031-d263af2a.svg";